import { render, staticRenderFns } from "./colAccionesBtnes.vue?vue&type=template&id=608cb9fc&"
import script from "./colAccionesBtnes.vue?vue&type=script&lang=js&"
export * from "./colAccionesBtnes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports